import * as helpers from '../helpers';

export default function splitStringWithBr(selector, maxWidth = 15) {
    const items = [...document.querySelectorAll(selector)];

    items
        .filter(item => !helpers.hasClass(item, 'js-is-inlined'))
        .forEach(item => {
            const width = item.getAttribute('data-max-length') || maxWidth;
            const lines = [];

            if (item.innerHTML.includes('<br>')) {
                const brExp = /<br\s*\/?>/i;
                const linesSplitBr = item.innerHTML.split(brExp);

                linesSplitBr.forEach(line => {
                    lines.push(helpers.formatString(line, Number(width), str => `<span>${str}</span>`));
                });

                item.innerHTML = lines.flat().join('');
            } else {
                const lines = helpers.formatString(item.textContent || item.innerText, Number(width), str => `<span>${str}</span>`);
                item.innerHTML = lines.join('');
            }

            helpers.addClass(item, 'js-is-inlined');
        });
}
